import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useStaticQuery, graphql } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';

const Head = ({ metaContent, pagePath, children }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
      contentfulAsset(title: { eq: "default-social-image-wide" }) {
        gatsbyImageData
      }
    }
  `);

  const { title, description, image } = metaContent;
  const imagePath = getSrc(image) || getSrc(data.contentfulAsset);

  return (
    <Helmet>
      <html lang="en" amp />
      <title>{`${title} | ${data.site.siteMetadata.title}`}</title>
      <meta
        name="description"
        content={
          description?.description ||
          'Juno College of Technology helps talented developers find success in careers they love through community-oriented classroom training and personalized support.'
        }
      />
      {pagePath && <link rel="canonical" href={`${data.site.siteMetadata.siteUrl}${pagePath}`} />}

      {/* Open Graph data / Facebook Card data */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={
          pagePath ? `${data.site.siteMetadata.siteUrl}${pagePath}` : data.site.siteMetadata.siteUrl
        }
      />
      <meta property="og:image" content={imagePath} />
      <meta property="og:image:alt" content="Juno College of Technology" />
      <meta
        property="og:description"
        content={
          description?.description ||
          'Juno College of Technology helps talented developers find success in careers they love through community-oriented classroom training and personalized support.'
        }
      />

      {/* Twitter Card data */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@junocollege" />
      <meta name="twitter:creator" content="@junocollege" />
      <meta name="twitter:title" content={title} />
      <meta
        name="twitter:description"
        content={
          description?.description ||
          'Juno College of Technology helps talented developers find success in careers they love through community-oriented classroom training and personalized support.'
        }
      />
      <meta name="twitter:image" content={imagePath} />

      {/* Pinterest */}
      <meta name="p:domain_verify" content="d9265092506e23ed70805b168623dd69" />

      {/* Windows Favicons - The rest of the favicons are generated by gatsby-plugin-manifest */}
      <meta name="msapplication-square70x70logo" content="/assets/mstile-70x70.png" />
      <meta name="msapplication-square144x144logo" content="/assets/mstile-144x144.png" />
      <meta name="msapplication-square150x150logo" content="/assets/mstile-150x150.png" />
      <meta name="msapplication-wide310x150logo" content="/assets/mstile-310x150.png" />
      <meta name="msapplication-square310x310logo" content="/assets/mstile-310x310.png" />

      {children}
    </Helmet>
  );
};

export default Head;
